import React from 'react';
import { Box } from '@mui/material';
import { colors, Icon, P } from '@manulife/mux';

export const ChecronButton = ({ children, ...props }) => {
  const styles = generateStyles();

  return (
    <Box sx={styles.ctn} {...props}>
      <Icon
        manulifeName="chevronleft_withcircle"
        fill={colors.coral}
        secondaryColor={colors.coral}
        className="icon-custom primary"
      />
      <Icon
        manulifeName="chevronleft_withcircle_filled"
        fill={colors.white}
        secondaryColor={colors.dark_1_coral}
        className="icon-custom secondary"
      />

      <P>{children}</P>
    </Box>
  );
};

const generateStyles = () => ({
  ctn: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',

    '& p': {
      margin: 0,
      fontFamily: 'Manulife JH Sans Optimized',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
    },

    '& .icon-custom': {
      width: '20px',
      height: '20px',
      display: 'flex',
    },

    '& .secondary': {
      display: 'none',
    },

    '&:hover': {
      '& .primary': {
        display: 'none',
      },
      '& .secondary': {
        display: 'flex',
      },
    },
  },
});
